import { observer } from "mobx-react";
import FontBody1 from "../../../../../../../../../components/fonts/font-body1/font-body1";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import { Tooltip } from "../../../../../../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../../../components/fonts/font-props";
import Icon from "../../../../../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../../../../../components/icons/icon-info/icon-info";
import { ICompareValueTypeComponentProps } from "../condition-field";
import PriceCompareValueStore from "../../../../../../../stores/compare-value/price-compare-value-store";
import currentPortalStore from "../../../../../../../../../stores/current-portal-store";

const PriceCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: PriceCompareValueStore = store as PriceCompareValueStore;
    const currency = currentPortalStore.setting?.currencyCode;

    return (
        <>
            {operatorSelector}

            <FontBody1>{currency}</FontBody1>

            <Input disabled={!condition.isEditMode} type={'number'} min={0} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v)} placeholder="0.00" />

            {condition.tooltip && (
                <Tooltip content={<div style={{ maxWidth: '200px' }}>
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                        {condition.tooltip}
                    </FontBody2>
                </div>}>
                    <Icon Component={IconInfo} />
                </Tooltip>
            )}
        </>
    );
});

export default PriceCompareValueField;